/**
 * @flow
 * @relayHash f0d387211bab8c14cc7d9f5cba8b048f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MediaFileStateType = "available" | "deleted" | "%future added value";
export type MediaFileTypeEnum = "image" | "live" | "video" | "wallpaper" | "%future added value";
export type MediaFileEditInput = {
  id: string,
  title?: ?string,
  description?: ?string,
  alt?: ?string,
  filename?: ?string,
  rating?: ?string,
  authors?: ?$ReadOnlyArray<?string>,
  type: MediaFileTypeEnum,
  status: string,
  preview?: ?string,
  topics?: ?$ReadOnlyArray<?string>,
  show?: ?string,
  slug?: ?string,
  seoTitle?: ?string,
  seoDescription?: ?string,
  seoKeywords?: ?string,
  state: MediaFileStateType,
  clientMutationId?: ?string,
};
export type MediaFileEditMutationVariables = {|
  input: MediaFileEditInput
|};
export type MediaFileEditMutationResponse = {|
  +MediaFileEdit: ?{|
    +mediaFile: ?{|
      +id: string
    |}
  |}
|};
export type MediaFileEditMutation = {|
  variables: MediaFileEditMutationVariables,
  response: MediaFileEditMutationResponse,
|};
*/


/*
mutation MediaFileEditMutation(
  $input: MediaFileEditInput!
) {
  MediaFileEdit(input: $input) {
    mediaFile {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "MediaFileEditInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "MediaFileEdit",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "MediaFileEditInput!"
      }
    ],
    "concreteType": "MediaFileEditPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "mediaFile",
        "storageKey": null,
        "args": null,
        "concreteType": "MediaFile",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "MediaFileEditMutation",
  "id": null,
  "text": "mutation MediaFileEditMutation(\n  $input: MediaFileEditInput!\n) {\n  MediaFileEdit(input: $input) {\n    mediaFile {\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "MediaFileEditMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "MediaFileEditMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '299d15de4e668e441ea6f7f7024adf1f';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/MediaFileEditMutation.graphql.js